import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jenkins/agent/workspace/allen-school-ui_main/packages/school/app/(auth)/login/login-client.tsx");
